/** localStorage helpers that never throw (private mode, blocked storage). */

const PREFIX = 'mailsmith.'

export function readStorage(key: string): string | null {
  try {
    return window.localStorage.getItem(PREFIX + key)
  } catch {
    return null
  }
}

export function writeStorage(key: string, value: string | null): void {
  try {
    if (value === null) window.localStorage.removeItem(PREFIX + key)
    else window.localStorage.setItem(PREFIX + key, value)
  } catch {
    // Storage is a convenience; ignore failures.
  }
}
